import axios from "axios";
import js_config from "utils/config-variables";

const loginCookie = window.env?.REACT_APP_LOGIN_COOKIE ?? "sl2sta_dev";
const instance = axios.create({
  baseURL: `${js_config.api_url}`,
  headers: {
    accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${document.cookie.match(`(^|;)\\s*${loginCookie}\\s*=\\s*([^;]+)`)?.pop() ?? ""}`,
  },
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status) {
      if (error.response.status === 401) {
        if (window.location.pathname !== "") {
          //TODO
          console.log("redirect to default page - 401 error");
        }
      } else if (error.response.status === 404 || error.response.status === 403) {
        //TODO
        console.log("redirect to default page - 404/403 error");
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
